export class Country {
    id:number;
    name:string;
    abbreviation:string;
    version:number;
}